import React from 'react';

import { isNotEmptyArray } from '@travel/utils';

import styles from './domesticErrorPage.module.scss';

type CommonLabels = {
  errorTitleLabel: string;
  followingMethodsLabel: string;
  helpPagesReferenceLabel: string;
};

export type ResolutionType = {
  id: string;
  label: React.ReactNode;
};

type Props = {
  commonLabels: CommonLabels;
  resolutionList: ResolutionType[];
  helpList: React.ReactNode[];
  helpTopPageLabel: React.ReactNode;
};

function DomesticErrorPageNoLabels(props: Props) {
  return (
    <main className={styles.wrapper} data-testid="domesticErrorPage-wrapper">
      <img
        className={styles.errorImg}
        src="https://trvimg.r10s.jp/share/common/images/sorry_img.png"
        alt="Computer displaying text Sorry"
        loading="lazy"
        data-testid="domesticErrorPage-img"
      />
      <h2 className={styles.errorTitle}>{props.commonLabels.errorTitleLabel}</h2>
      {isNotEmptyArray(props.resolutionList) && (
        <div className={styles.resolutionList}>
          <span className={styles.listTitle}>{props.commonLabels.followingMethodsLabel}</span>
          <ul data-testid="domesticErrorPage-resolutionList-container">
            {props.resolutionList.map((resolution) => {
              return (
                <li key={`${resolution.id}`} className={styles.listItem}>
                  {resolution.label}
                </li>
              );
            })}
          </ul>
        </div>
      )}
      {isNotEmptyArray(props.helpList) && (
        <>
          <span className={styles.faqLabel}>{props.commonLabels.helpPagesReferenceLabel}</span>
          <div className={styles.faqList} data-testid="domesticErrorPage-faqList-container">
            {props.helpList}
          </div>
        </>
      )}
      <p className={styles.faqLink}>{props.helpTopPageLabel}</p>
    </main>
  );
}

export default DomesticErrorPageNoLabels;
